var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('div',{attrs:{"id":"ad"}},[_c('a',{attrs:{"href":"https://hack.bestian.tw","target":"_blank","rel":"noopener noreferrer"}},[_c('img',{staticClass:"ad",attrs:{"src":"/ad-be.jpg","alt":"本站由Bestian製作"}}),_vm._v("本站由Bestian製作")])])])
}]

export { render, staticRenderFns }